import { loader } from 'graphql.macro'

export default async function updateSiteType ({ dataLoaders, variables }) {
  const schema = loader('./updateSiteType.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      siteTypeId: variables.siteTypeId,
      name: variables.name,
      shortCode: variables.shortCode,
      status: variables.status
    }
  })
  return response.updateSiteType
}
